import { useEffect, useRef, useState } from "react";
import {
  FaBars,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTimes,
  FaUserCircle,
} from "react-icons/fa";
import "./Lheader.css";
import logo from "../../Assets/uslot-ai-logo.png";
import { Button } from "primereact/button";
import { RiArrowRightLine } from "react-icons/ri";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import config from "../../config";
import { Link } from "react-router-dom";
import { CiLogout } from "react-icons/ci";
import { MdLanguage } from "react-icons/md";
import { Dropdown } from "primereact/dropdown";
import { useRecoilState } from "recoil";
import { selectedLang } from "../../utils/recoil";
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

function Lheader() {
  const navRef = useRef();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const usernameCookie = Cookies.get("username", {
    domain: config.cookieDomain,
  });
  const profileImage = Cookies.get("picture", { domain: config.cookieDomain });
  const tokenCookie = Cookies.get("token", { domain: config.cookieDomain });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    
    // In case the user resizes before mounting is complete
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [lang, setLang] = useRecoilState(selectedLang);
  const { t } = useTranslation("home");

  const location = useLocation();
  const currentUrl = location.pathname;

  const [cities, setCities] = useState([
    { name: "English", code: "en" },
    // { name: "Hindi", code: "hi" },
    // { name: "Malayalam", code: "mal" },
    { name: "Arabic", code: "ar" },
    // { name: "Tamil", code: "ta" },
  ]);

  useEffect(() => {
    if (location.pathname === "/detail_result_page") {
      setCities([
        { name: "English", code: "en" },
        { name: "Hindi", code: "hi" },
        { name: "Malayalam", code: "mal" },
        { name: "Arabic", code: "ar" },
        { name: "Tamil", code: "ta" },
      ]);
    }
  }, [location])

  // const cities = [
  //   { name: "English", code: "en" },
  //   { name: "Hindi", code: "hi" },
  //   { name: "Malayalam", code: "mal" },
  //   { name: "Arabic", code: "ar" },
  //   { name: "Tamil", code: "ta" },
  // ];

  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
    setIsNavbarOpen((prev) => !prev);
  };

  useEffect(() => {
    if (isNavbarOpen) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "";
    }
    // Clean up in case component unmounts while nav is open
    return () => {
      document.body.style.overflowY = "";
    };
  }, [isNavbarOpen]);

  const changeLanguage = (e) => {
    console.log(e.value);
    localStorage.setItem("lang", e.value.code);
    setLang(e.value);
    try {
      i18n.changeLanguage(e.value.code);
    } catch (err) {
      // no-op
    }
    // setSearchParams((prev) => ({
    //   ...prev,
    //   lang: e.value.code,
    // }));
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("lang", e.value.code);
      return next;
    });
    if (isMobile) {
      showNavbar();
    }
  };

  const goToProfile = () => {
    if (tokenCookie) {
      if (location.search) {
        navigate({ pathname: "/my_profile", search: location.search });
      } else {
        navigate("/path");
      }
    }
  };

  // const changei18n = () => {
  //   i18n.changeLanguage("hi");
  // };

  const removeFromLocalStorage = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("result");
  };

  return (
    <div className="header-main z-[1000] relative">
      <header>
        {/* <button onClick={changei18n}>hello</button> */}
        <div>
          <Link to={"/"}>
            <img className="header-logo object-contain" src={logo} />
          </Link>
          <div className="navs">
            <nav ref={navRef}>
              <img
                src={logo}
                className="header-logo object-contain md-max:flex hidden"
              />

              <a href="/#" onClick={() => isMobile && showNavbar()}>
                {t("nav.home")}
              </a>
              <a href="/about" onClick={() => isMobile && showNavbar()}>
                {t("nav.about")}
              </a>
              <a href="/#faq" onClick={() => isMobile && showNavbar()}>
                {t("nav.faq")}
              </a>
              <a href="/#review" onClick={() => isMobile && showNavbar()}>
                {t("nav.reviews")}
              </a>
              
              {tokenCookie && (
                <button
                  className="md-max:block hidden text-[1.5rem] font-medium"
                  onClick={() =>
                    isMobile && [showNavbar(), navigate("/logout")]
                  }
                >
                  {t("nav.logout")}
                </button>
              )}
              <div className="items-center px-2 bg-white rounded-md md-max:flex hidden">
                <MdLanguage size={40} color="#3976F9" className="font-normal" />
                <Dropdown
                  // value={searchParams.get("lang") ?? lang}
                  value={cities?.find(
                    (city) => city.code === searchParams.get("lang") ?? lang
                  )}
                  // onChange={(e) =>
                  //   startTransition(() => {
                  //     setLang(e.value);
                  //   })
                  // }
                  onChange={(e) => changeLanguage(e)}
                  options={cities}
                  optionLabel="name"
                  placeholder="Language"
                  className="px-6 py-3 text-[16px ] "
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "black",
                    width: "150px",
                  }}
                />
              </div>

              <hr className="h-1 bg-gray-100 w-[90%] hidden" />

              <div className="items-center gap-8 md-max:flex hidden">
                <Link
                  to={"https://www.facebook.com/profile.php?id=61575990883324"}
                  target="_blank"
                  className="m-0"
                >
                  <FaFacebook size={40} color="#1C75BC" />
                </Link>
                <Link
                  to={"https://www.instagram.com/uslot_ai/"}
                  target="_blank"
                  className="m-0"
                >
                  <FaInstagram size={40} color="#1C75BC" />
                </Link>
                <Link
                  to={"https://www.linkedin.com/in/uslot-ai-ab87ba365"}
                  target="_blank"
                  className="m-0"
                >
                  <FaLinkedin size={40} color="#1C75BC" />
                </Link>
              </div>
              {/* {currentUrl === "detail_result_page" && ( */}
                <div className="flex items-center px-2 bg-white rounded-md md-max:hidden">
                  <MdLanguage
                    size={40}
                    color="#3976F9"
                    className="font-normal"
                  />
                  <Dropdown
                    // value={searchParams.get("lang") ?? lang}
                    value={cities?.find(
                      (city) => city.code === searchParams.get("lang") ?? lang
                    )}
                    // onChange={(e) =>
                    //   startTransition(() => {
                    //     setLang(e.value);
                    //   })
                    // }
                    onChange={(e) => changeLanguage(e)}
                    options={cities}
                    optionLabel="name"
                    placeholder="Language"
                    className="px-6 py-3 text-[16px ] "
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "black",
                      width: "150px",
                    }}
                  />
                </div>
              {/* )} */}

              <button className="nav-btn nav-close-btn" onClick={showNavbar}>
                <FaTimes />
              </button>
            </nav>
          </div>
        </div>

        <button className="nav-btn" onClick={showNavbar}>
          <FaBars />
        </button>

        {!tokenCookie ? (
          <>
          <div className="items-center px-2 bg-white rounded-md md-max:hidden hidden">
          <MdLanguage size={40} color="#3976F9" className="font-normal" />
          <Dropdown
            // value={searchParams.get("lang") ?? lang}
            value={cities?.find(
              (city) => city.code === searchParams.get("lang") ?? lang
            )}
            // onChange={(e) =>
            //   startTransition(() => {
            //     setLang(e.value);
            //   })
            // }
            onChange={(e) => changeLanguage(e)}
            options={cities}
            optionLabel="name"
            placeholder="Language"
            className="px-6 py-3 text-[16px ] "
            style={{
              fontSize: "16px",
              fontWeight: "500",
              color: "black",
              width: "150px",
            }}
          />
        </div>
          <Button
            onClick={() => navigate("/login")}
            className="header-login-link"
          >
            {t("nav.loginSignup")} <RiArrowRightLine />
          </Button>
          </>
        ) : (
          <div className="flex gap-10 md-max:hidden">
            <div onClick={goToProfile}>
              <button className="flex gap-4 items-center">
                <span
                  className="truncate max-w-[10rem] border-b p-1.5"
                  style={{ borderBottom: "1px solid #1C75BC" }}
                >
                  {t("nav.hello")}{" "}
                  {usernameCookie && usernameCookie.split("-").join(" ")}
                </span>
                {profileImage ? (
                  <img
                    src={profileImage}
                    alt="profile-img"
                    width="38px"
                    height="38px"
                    style={{ borderRadius: "50%" }}
                  />
                ) : (
                  <FaUserCircle size={38} color="#3976F9" />
                )}
              </button>
            </div>
            {currentUrl === "/instruction" ||
            currentUrl === "/result-page" ||
            currentUrl === "/my_profile" ||
            currentUrl === "/detail_result_page" ||
            currentUrl === "/rough" ||
            currentUrl === "/" ? (
              <></>
              // <div className="flex items-center px-2 bg-white rounded-md">
              //   <MdLanguage size={40} color="#3976F9" className="font-normal" />
              //   <Dropdown
              //     // value={searchParams.get("lang") ?? lang}
              //     value={cities?.find(
              //       (city) => city.code === searchParams.get("lang") ?? lang
              //     )}
              //     // onChange={(e) =>
              //     //   startTransition(() => {
              //     //     setLang(e.value);
              //     //   })
              //     // }
              //     onChange={(e) => changeLanguage(e)}
              //     options={cities}
              //     optionLabel="name"
              //     placeholder="Language"
              //     className="px-6 py-3 text-[16px ] "
              //     style={{
              //       fontSize: "16px",
              //       fontWeight: "500",
              //       color: "black",
              //       width: "150px",
              //     }}
              //   />
              // </div>
            ) : (
              // <div
              //   onClick={() => navigate("/logout")}
              //   // className="quiz-headerprofile-buttons"
              //   style={{ gap: "5px" }}
              // >
              //   <button>
              //     {/* Logout */}
              //     <CiLogout size={38} color="#3976F9" />
              //   </button>
              // </div>
              <div></div>
            )}
            {/* {currentUrl === "/detail_result_page" && ( */}
            <></>
            {/* <div className="items-center px-2 bg-white rounded-md md-max:flex hidden">
              <MdLanguage size={40} color="#3976F9" className="font-normal" />
              <Dropdown
                // value={searchParams.get("lang") ?? lang}
                value={cities?.find(
                  (city) => city.code === searchParams.get("lang") ?? lang
                )}
                // onChange={(e) =>
                //   startTransition(() => {
                //     setLang(e.value);
                //   })
                // }
                onChange={(e) => changeLanguage(e)}
                options={cities}
                optionLabel="name"
                placeholder="Language"
                className="px-6 py-3 text-[16px ] "
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "black",
                  width: "150px",
                }}
              />
            </div> */}
            <div
              onClick={() => {navigate("/logout"); removeFromLocalStorage()}}
              className="quiz-headerprofile-buttons"
              style={{ gap: "5px" }}
            >
              <button>
                <CiLogout size={38} color="#3976F9" />
              </button>
            </div>
            {/* )} */}
          </div>
        )}
      </header>
    </div>
  );
}

export default Lheader;
